(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-bag-coffee"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('two-bag-coffee')) {
  class TwoBagCoffee extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.catalog = JSON.parse(this.querySelector('[data-catalog]').textContent);
      this.products = this.catalog.products.filter(product => product.id && !product.requiresSellingPlan);
      this.pack = this.catalog.pack;
      this.strings = this.catalog.strings;
      this.bags = [...this.querySelectorAll('[data-bag]')];
      this.button = this.querySelector('[data-submit]');
      this.buttonLabel = this.querySelector('[data-submit-label]');
      this.status = this.querySelector('[data-status]');
      this.review = this.querySelector('[data-review]');
      this.reviewOnly = this.dataset.offerEnabled !== 'true';
      this.busy = false;
      this.completed = false;
      this.uncertain = false;
      this.money = new Intl.NumberFormat(this.dataset.locale || 'en-US', { style: 'currency', currency: 'USD' });
      this.bags.forEach(bag => {
        bag.querySelector('[data-coffee]').addEventListener('change', () => { this.populateBag(bag); this.updateTotal(); });
        bag.querySelector('[data-grind]').addEventListener('change', () => this.updateTotal());
        this.populateBag(bag);
      });
      this.querySelector('[data-pair-form]').addEventListener('submit', event => { event.preventDefault(); this.addPair(); });
      this.updateTotal();
      this.onPageShow = event => { if (event.persisted) { this.busy = false; this.completed = false; this.lock(false); this.updateTotal(); } };
      window.addEventListener('pageshow', this.onPageShow);
    }
    disconnectedCallback() { window.removeEventListener('pageshow', this.onPageShow); }
    productFor(bag) { return this.products.find(product => String(product.id) === bag.querySelector('[data-coffee]').value); }
    variantFor(bag) { return this.productFor(bag)?.variants.find(variant => String(variant.id) === bag.querySelector('[data-grind]').value); }
    packReady() { return this.pack?.id && this.pack.available && this.pack.price === 4000 && !this.pack.requiresSellingPlan && this.dataset.currency === 'USD'; }
    populateBag(bag) {
      const product = this.productFor(bag);
      const select = bag.querySelector('[data-grind]');
      const oldGrind = select.selectedOptions[0]?.dataset.grind || select.selectedOptions[0]?.textContent;
      select.replaceChildren();
      if (!product) return;
      product.variants.forEach(variant => {
        const option = document.createElement('option');
        option.value = String(variant.id);
        option.dataset.grind = variant.grind;
        option.textContent = variant.grind + (variant.available ? '' : ' — ' + this.strings.soldOut);
        option.disabled = !variant.available;
        select.append(option);
      });
      const preferred = product.variants.find(variant => variant.available && variant.grind === oldGrind) || product.variants.find(variant => variant.available);
      select.value = preferred ? String(preferred.id) : '';
      bag.querySelector('[data-title]').textContent = product.title;
      bag.querySelector('[data-roast]').textContent = product.roast;
      bag.querySelector('[data-notes]').textContent = product.notes;
      const image = bag.querySelector('.tb-bag-image');
      image.removeAttribute('srcset');
      image.src = product.image;
      image.alt = product.alt || product.title;
    }
    updateTotal() {
      const variants = this.bags.map(bag => this.variantFor(bag));
      const choicesReady = variants.length === 2 && variants.every(variant => variant?.available);
      this.bags.forEach(bag => { bag.querySelector('[data-bag-price]').textContent = this.strings.includedBag; });
      this.querySelectorAll('[data-pair-price]').forEach(element => { element.textContent = this.money.format(40); });
      const ready = this.packReady() && choicesReady && !this.reviewOnly;
      this.button.disabled = !ready || this.busy || this.completed || this.uncertain;
      if (!this.busy && !this.completed && !this.uncertain) this.buttonLabel.textContent = this.reviewOnly ? this.strings.preview : ready ? this.strings.add : this.strings.unavailable;
      if (!this.uncertain && !this.busy) { this.status.textContent = !this.reviewOnly && !this.packReady() ? this.strings.offerUnavailable : ''; this.review.hidden = true; }
    }
    lock(locked) {
      this.setAttribute('aria-busy', String(locked));
      this.bags.forEach(bag => { bag.disabled = locked; });
      this.button.disabled = locked;
    }
    async verifyCurrentSelections(products, variants) {
      const requested = [...new Map([...products, { id: this.pack.productId, url: this.pack.url }].map(product => [product.id, product])).values()];
      const current = await Promise.all(requested.map(async product => {
        const response = await fetch(product.url + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!response.ok) throw new Error('Unavailable');
        const data = await response.json();
        if (data.id !== product.id || data.requires_selling_plan) throw new Error('Unavailable');
        return data;
      }));
      const packProduct = current.find(product => product.id === this.pack.productId);
      const packVariant = packProduct?.variants.find(variant => variant.id === this.pack.id);
      if (!packVariant?.available || packVariant.price !== 4000 || packVariant.requires_selling_plan) throw new Error('Unavailable');
      products.forEach((product, index) => {
        const currentVariant = current.find(item => item.id === product.id)?.variants.find(variant => variant.id === variants[index].id);
        if (!currentVariant?.available || currentVariant.option1 !== '12 oz' || currentVariant.option2 !== variants[index].grind || currentVariant.requires_selling_plan) throw new Error('Unavailable');
      });
    }
    async addPair() {
      if (this.reviewOnly || this.busy || this.completed || this.uncertain) return;
      const products = this.bags.map(bag => this.productFor(bag));
      const variants = this.bags.map(bag => this.variantFor(bag));
      if (!this.packReady() || products.length !== 2 || products.some(product => !product) || variants.some(variant => !variant?.available)) { this.status.textContent = this.strings.selectError; return; }
      const properties = {
        [this.strings.bagOneCoffee]: products[0].title,
        [this.strings.bagOneGrind]: variants[0].grind,
        [this.strings.bagTwoCoffee]: products[1].title,
        [this.strings.bagTwoGrind]: variants[1].grind,
        [this.strings.bagSize]: this.strings.bagSizeValue
      };
      this.busy = true;
      this.lock(true);
      this.status.textContent = '';
      this.buttonLabel.textContent = this.strings.pending;
      let postStarted = false;
      try {
        await this.verifyCurrentSelections(products, variants);
        postStarted = true;
        const response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: this.pack.id, quantity: 1, properties }] }) });
        const result = await response.json();
        if (!response.ok) {
          this.uncertain = true;
          this.status.textContent = typeof result.description === 'string' ? result.description + ' ' + this.strings.error : this.strings.error;
          this.review.hidden = false;
          this.buttonLabel.textContent = this.strings.unavailable;
          return;
        }
        this.completed = true;
        this.buttonLabel.textContent = this.strings.success;
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.uncertain = true;
        this.status.textContent = postStarted ? this.strings.error : this.strings.refresh;
        this.review.hidden = !postStarted;
        this.buttonLabel.textContent = this.strings.unavailable;
      } finally {
        this.busy = false;
        if (!this.completed) this.lock(false);
        this.button.disabled = this.completed || this.uncertain;
      }
    }
  }
  customElements.define('two-bag-coffee', TwoBagCoffee);
}

  } catch(e) { console.error(e); }
})();
})();
